import { log } from 'log';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { showGeofencingPopupAction } from '../actions';
import * as helpers from '../helpers';

export const useReceivePacket = ({
    transactionID,
    triggerGeolocation,
    setShowOverlay,
    useTransparentPopup,
    geolocationType
}: {
    transactionID: string | null;
    triggerGeolocation: CallableFunction;
    setShowOverlay: (showOverlay: boolean) => void;
    useTransparentPopup: boolean;
    geolocationType: string;
}) => {
    const dispatch = useDispatch();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const closePopups = useSmartClosePopups();

    return useCallback(async (geoPacket) => {
        log('gcRes', {
            transactionID,
            geoPacket
        });

        try {
            const response = await validateGeolocation(null, null, geoPacket, transactionID, null, geolocationType);

            if (response.data.errorCode === 0) {
                // all good
                setShowOverlay(false);
            }
        } catch (response: any) {
            switch (response.data.errorCode) {
                case 109:
                    // do nothing here, just try again
                    break;
                case 105:
                    // location is not allowed
                    setShowOverlay(false);
                    dispatch(showGeofencingPopupAction({
                        title: 'playtech.mobile.system.geocomply.popups.notAllowed.title',
                        content: response.data.playerMessage,
                        isModal: true,
                        buttons: [
                            {
                                onClick: () => closePopups(),
                                text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                                color: 'negative'
                            },
                            {
                                onClick: onRefresh,
                                text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                                color: 'info'
                            }
                        ],
                        useTransparentPopup
                    }));

                    // do not continue with geolocation
                    return;
                default:
                // noop
            }
        } finally {
            helpers.unsetTransactionHandlerUUID(transactionID ?? '');
        }

        await triggerGeolocation();
    }, [
        closePopups,
        onRefresh,
        transactionID,
        dispatch,
        triggerGeolocation,
        setShowOverlay,
        useTransparentPopup,
        geolocationType
    ]);
};
